import { render, staticRenderFns } from "./FiltersModule.vue?vue&type=template&id=241126b4&scoped=true&"
import script from "./FiltersModule.vue?vue&type=script&lang=js&"
export * from "./FiltersModule.vue?vue&type=script&lang=js&"
import style0 from "./FiltersModule.vue?vue&type=style&index=0&id=241126b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241126b4",
  null
  
)

export default component.exports